module.exports = __webpack_public_path__ + "img/team-1.6199a2ce.jpg";